import { useSnapshot } from "valtio"
import {
  configStore,
  loginStore,
  routerStore,
  AgmodalStore,
  RolesStore,
} from "../state/CommonState"
import { useEffect, useState } from "react"
import RoleUtils from "../util/RoleUtils"
import { PERMISSIONS, ROLES, VERTICALS } from "../util/constants"
import { loader } from "../util/loader"
import { ReactComponent as Loader } from "../assets/loader.svg"
import { Columns, Col4 } from "../Controls"
import "../style.css"
import RolesApi from "../state/RolesApi"
import { ServerLists } from "../StaticData"

export default function EditRole({ mode }) {
  // Subscribe to state stores
  useSnapshot(AgmodalStore)
  useSnapshot(RolesStore)

  const [formObject, setFormObject] = useState({ roleName: "" })
  const [loading, setLoading] = useState(false)
  const [errorObject, setErrorObject] = useState({
    roleName: "",
    permissions: "",
  });
  const Roles = RolesStore.RolesRec // Assuming this holds the current role info

  // Determine title based on mode
  const title =
    mode === "edit"
      ? "Edit Role & Permissions"
      : mode === "new"
      ? "Add Role & Permissions"
      : "Role"

  useEffect(() => {
    // Perform any initialization based on mode.
    if (mode === "new") {
      setFormObject({ roleName: "" })
    } else if (mode === "edit") {
      setFormObject({ roleName: RolesStore.RolesRec?.roleName || "" })
    }
  }, [mode])

  const handleCancel = () => {
    AgmodalStore.pageVisible = false
    AgmodalStore.apiCall = true
    routerStore.rolesCurrentView = "list"
  }

  const onFormSubmit = async () => {
    if (errorObject.roleName || errorObject.permissions) {
      setLoading(false);
      return;
    }
    await RolesApi.apiCreateRole(setLoading, Roles);
    setLoading(false);
  };

  const handleSubmit = () => {
    let errors = { roleName: "", permissions: "" };

    if (!Roles.roleName.trim()) {
      errors.roleName = "Role name is required";
    }

    if (Roles.permissions.length === 0) {
      errors.permissions = "At least select a single permission";
    }

    setErrorObject(errors);

    if (!errors.roleName && !errors.permissions) {
      setLoading(true);
      onFormSubmit();
    }
  };

  const isViewMode = mode === "view"

  // Common button style (override margins as needed)
  const buttonStyle = {
    backgroundColor: "#32a893",
    border: "none",
    padding: "1%",
    borderRadius: "8px",
    color: "white",
    fontWeight: "600",
    marginTop: "5%",
    width: "70px",
    cursor: "pointer",
  }

  const handleOnChange = (e) => {
    const { value } = e.target;
    Roles.roleName = value;

    const duplicate = RolesStore.list?.some(
      (role) => role.roleName.toLowerCase() === value.trim().toLowerCase()
    );

    if (duplicate) {
      setErrorObject((prev) => ({ ...prev, roleName: "Role name already exists" }));
    } else {
      setErrorObject((prev) => ({ ...prev, roleName: "" }));
    }
  };

  const permissionsList = ServerLists.permissionsList

  const permissionsData = permissionsList.reduce((acc, { _id, permissionName, category }) => {
    if (!acc[category]) {
      acc[category] = []
    }
    acc[category].push({ id: _id, permissionName })
    return acc
  }, {})

    const [expandedSections, setExpandedSections] = useState({});
  
    const toTitleCase = (text) => {
      return text
        .replace(/([A-Z])/g, " $1") // Add space before uppercase letters
        .trim()
        .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter
        .replace(/\s\/\s/g, "/") // Keep slashes formatted
        .replace(/Vehicle Driver User Audit Reports/i, "Vehicle/Driver/User/Audit/Reports") // Exact match fix
        .replace(/Bookings Visibility My Action/i, "Bookings/Visibility/My Action"); // Exact match fix
    };
  
    const toggleSection = (section) => {
      setExpandedSections((prev) => ({
        ...prev,
        [section]: !prev[section],
      }));
    };
  
    const handlePermissionChange = (permissionId) => {
      if (Roles.permissions.includes(permissionId)) {
          Roles.permissions = Roles.permissions.filter(id => id !== permissionId);
      } else {
          Roles.permissions.push(permissionId);
      }
      setErrorObject((prev) => ({
        ...prev,
        permissions: Roles.permissions.length === 0 ? "At least select a single permission" : "",
      }));
  };
  
  const handleSelectAll = (category) => {
    const allPermissions = permissionsData[category].map((perm) => perm.id);
    const allSelected = allPermissions.every((id) => Roles.permissions.includes(id));

    Roles.permissions = allSelected
        ? Roles.permissions.filter(id => !allPermissions.includes(id)) // Remove all
        : [...new Set([...Roles.permissions, ...allPermissions])]; // Add all

    setErrorObject((prev) => ({
      ...prev,
      permissions: Roles.permissions.length === 0 ? "At least select a single permission" : "",
    }));
};


  

  return (
    <div className="container is-fullheight" id="editRole">
      <h1 className="title">{title}</h1>
      <div style={{ padding: "0rem" , marginTop:'2rem'}}>
        <Columns>
          <Col4>
            <h1 className="label is-medium" style={{ marginBottom: "0px" ,fontWeight: "normal" }}>
              Role Name *
            </h1>
          </Col4>
          <Col4>
            <div className="is-flex" style={{ flexDirection: "column" }}>
              <input
                maxLength={25}
                type="text"
                className="input is-small"
                id="roleName"
                value={Roles.roleName || ""}
                onChange={handleOnChange}
              />
               {errorObject.roleName && (
                <p style={{ color: "red", fontSize: "0.8rem", marginTop: "0.5rem" }}>
                  {errorObject.roleName}
                </p>
              )}
            </div>
          </Col4>
        </Columns>
      </div>
      <div style={{ padding: "0rem", marginTop:'2rem' }}>
      {/* Permissions */}
      <Columns>
      <Col4>
      <h4 className="label is-medium" style={{ marginBottom: "0px",fontWeight: "normal"  }}>Permissions *</h4>
      </Col4>
      <Col4>
      <div style={{ border: "1px solid #ddd", borderRadius: "5px", padding: "10px" }}>
      {Object.entries(permissionsData).map(([category, permissions]) => {
        const selectedCount = permissions.filter((perm) => Roles.permissions.includes(perm.id)).length;
        return (
          <div key={category} style={{ marginBottom: "8px" }}>
            <div
              onClick={() => toggleSection(category)}
              style={{
                cursor: "pointer",
                fontWeight: "bold",
                padding: "10px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              <span>{toTitleCase(category)}</span>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                {selectedCount > 0 && (
                  <span
                    style={{
                      background: "#ddd",
                      borderRadius: "50%",
                      padding: "4px 8px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: "20px",
                      height: "20px",
                    }}
                  >
                    {selectedCount}
                  </span>
                )}
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{
                    transform: expandedSections[category] ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s ease",
                  }}
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </div>
            </div>

            {expandedSections[category] && (
              <div style={{ paddingLeft: "15px", paddingTop: "5px" }}>
                {permissions.length > 0 ? (
                  <>
                    <div style={{ marginBottom: "5px" }}>
                      <input
                        type="checkbox"
                        onChange={() => handleSelectAll(category)}
                        checked={permissions.every((perm) => Roles.permissions.includes(perm.id))}
                      />
                      <label style={{ marginLeft: "5px", fontWeight: "bold" }}>Select All</label>
                    </div>
                    {permissions.map((permission) => (
                      <div key={permission.id} style={{ marginBottom: "3px" }}>
                        <input
                          type="checkbox"
                          id={permission.id}
                          checked={Roles.permissions.includes(permission.id)}
                          onChange={() => handlePermissionChange(permission.id)}
                        />
                        <label htmlFor={permission.id} style={{ marginLeft: "5px" }}>
                          {permission.permissionName}
                        </label>
                      </div>
                    ))}
                  </>
                ) : (
                  <p style={{ fontSize: "12px", color: "#666" }}>No permissions available</p>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
    {errorObject.permissions && (
              <p style={{ color: "red", fontSize: "0.8rem", marginTop: "0.5rem" }}>
                {errorObject.permissions}
              </p>
            )}
      </Col4>
      </Columns>
    </div>

      <div className="is-flex">
        <button
          className="button is-primary"
          onClick={handleCancel}
          style={{ ...buttonStyle, marginLeft: "83%" }}
        >
          CANCEL
        </button>
        {!isViewMode && (
          <button
            className="button is-primary"
            onClick={handleSubmit}
            style={{ ...buttonStyle, marginLeft: "1%" }}
            disabled={loading || errorObject.roleName !== ""}
          >
            {!loading ? "SUBMIT" : <Loader className="spinner" />}
          </button>
        )}
      </div>
    </div>
  )
}

